import {useSession} from 'next-auth/react';
import {usePathname, useRouter, useSearchParams} from 'next/navigation';
import {useEffect, useRef} from 'react';

interface useAuthGuardArgs {
  signIn: string;
}

/**
 * @description Redirects the user to the login page if they are not authenticated and not already on the login page
 */
const useAuthGuard = ({signIn}: useAuthGuardArgs): void => {
  const {status} = useSession();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const hasRedirected = useRef<boolean>(false);

  useEffect(() => {
    const handleRedirect = (url: string): void => {
      if (!hasRedirected.current) {
        router.replace(url);
        hasRedirected.current = true;
      }
    };

    if (status === `unauthenticated` && pathname !== signIn) {
      handleRedirect(`/login?${searchParams.toString()}`);
    } else if (status === `authenticated` && pathname === signIn) {
      handleRedirect(`/`);
    }
  }, [status, pathname, router, searchParams, signIn]);
};

export default useAuthGuard;
